import { Icon } from "../../lib";
import React from "react";

export default () => (<Icon />);



// WEBPACK FOOTER //
// ./src/Icon/demo/simpleUse.js